import React from 'react';

const DealerLPFormSuccessSVG = () => {
  return (
    <svg
      width="187"
      height="155"
      viewBox="0 0 187 155"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M30.6619 92.6217C30.4096 91.7374 30.1572 90.7267 30.1572 89.716C30.4096 87.9474 31.6714 86.5577 33.0594 85.5471C34.4474 84.5364 35.9615 83.6521 37.0972 82.3887C40.2517 78.8514 39.3684 73.2928 41.0088 68.8711C41.7659 71.9031 42.3968 74.9351 42.3968 77.9671C42.3968 80.9991 41.7659 84.1574 39.9993 86.8104C37.7281 90.2214 34.9521 92.748 33.3117 96.538C31.6714 95.9064 31.1667 94.1377 30.6619 92.6217Z"
          fill="#058293"
        />
        <path
          d="M20.189 96.0322C17.6654 94.6426 14.7632 94.5162 11.9872 95.0216C9.21126 95.5269 6.56146 96.6639 4.03784 97.8009C6.68764 97.9272 9.33744 98.1799 11.6087 99.4432C13.6276 100.58 15.0156 102.349 16.7821 103.739C19.0534 105.381 28.2646 108.034 30.0311 104.244C31.1667 101.97 22.2079 97.0429 20.189 96.0322Z"
          fill="#058293"
        />
        <path
          d="M37.4758 94.8956C38.6114 92.1163 41.0088 89.9686 43.1539 87.9473C42.523 92.4953 42.3968 97.2959 42.7754 101.844C42.9015 103.613 43.1539 105.381 42.6492 107.024C41.0088 112.709 38.2328 108.287 37.3496 105.255C36.4663 101.844 36.0878 98.1802 37.4758 94.8956Z"
          fill="#058293"
        />
        <path
          d="M29.5264 108.92C28.0122 109.046 26.6243 109.551 25.1101 110.183C21.9556 111.446 18.801 112.71 15.7727 114.099C19.6843 114.352 23.5959 114.099 27.3813 113.215C28.2646 112.962 29.2741 112.836 30.1573 112.962C31.9239 113.215 33.1857 114.731 34.4475 115.994C37.2234 118.395 44.2896 118.016 40.7565 113.594C38.7376 110.941 32.6809 108.667 29.5264 108.92Z"
          fill="#058293"
        />
        <path
          d="M15.268 87.1885C13.6276 85.5462 12.1134 83.7775 11.3563 81.6299C10.4731 79.4822 10.3469 77.0819 11.2302 75.0605C11.6087 77.0819 11.9873 79.2295 13.5014 80.6192C14.5109 81.6299 15.8989 82.1352 17.2868 82.7669C20.8199 84.5355 24.7315 88.3255 25.2362 92.4945C21.7032 92.6209 17.6654 89.4625 15.268 87.1885Z"
          fill="#058293"
        />
        <path
          d="M23.4697 71.6512C23.8482 69.6299 24.8577 67.8612 25.8671 65.9662C26.498 64.8292 27.2551 63.5659 28.5169 63.0605C28.2645 65.8399 28.0122 68.6192 27.6336 71.5249C27.5075 73.2935 27.2551 75.0622 27.5075 76.9572C27.7598 79.1049 28.0122 85.6742 24.3529 81.7578C22.7126 79.7365 23.0911 73.9252 23.4697 71.6512Z"
          fill="#058293"
        />
        <path
          d="M14.1323 69.6292C13.6275 67.1025 13.6275 64.4495 12.4919 62.0492C10.8516 58.3855 6.93995 56.2379 3.15452 54.8482C2.01889 54.3429 0.504723 53.8375 0 52.5742C3.02834 53.0796 6.18286 53.5849 9.08502 54.7219C11.9872 55.8589 14.7632 57.6275 16.4035 60.2805C18.5486 63.5652 19.558 69.1238 18.8009 73.0402C17.6653 78.7252 14.7632 72.7875 14.1323 69.6292Z"
          fill="#058293"
        />
        <path
          d="M15.394 65.334C16.1511 67.7343 16.782 70.1346 17.2868 72.535C17.6653 74.3036 18.0438 76.1986 18.8009 77.841C19.8104 80.2413 21.4507 82.2626 23.0911 84.4103C26.498 89.0846 29.5263 94.1379 31.6714 99.5702C32.5546 101.465 33.1855 103.487 34.4473 105.255C36.971 109.172 41.1349 111.572 43.7847 115.362C45.9298 118.52 47.0654 122.31 47.3178 126.1C47.444 128.627 47.3178 131.154 47.6963 133.68C48.0749 136.207 48.9581 138.734 50.7247 140.502"
          stroke="#00B0AC"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.3625 71.5234C23.8483 76.1978 25.2363 81.3774 24.353 86.3044"
          stroke="#00B0AC"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M37.4757 85.5469C36.7186 86.3049 35.7091 86.6839 35.0782 87.4419C34.6997 87.9472 34.5735 88.4525 34.3211 88.9579C33.8164 90.4739 33.1855 92.1162 33.1855 93.7585C33.1855 94.8955 33.3117 96.1589 33.3117 97.2959C33.3117 98.4329 33.0593 99.8225 32.3022 100.581"
          stroke="#00B0AC"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.9994 111.319C40.3779 109.298 40.3779 107.15 39.9994 105.002C39.4947 102.476 38.4852 99.9491 38.6114 97.4224C38.6114 96.6644 38.8638 95.7801 39.3685 95.1484"
          stroke="#00B0AC"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.4036 98.6855C18.9272 100.96 22.2079 101.97 25.4886 102.728C26.6242 102.981 27.6337 103.234 28.7693 103.234C29.5264 103.234 30.1573 102.981 30.9144 103.107C31.7976 103.107 32.6809 103.486 33.3118 103.992"
          stroke="#00B0AC"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.9331 111.572C34.952 111.825 36.9709 112.457 38.6112 113.72C39.4945 114.352 40.3778 115.236 41.3872 115.741C41.7658 115.994 42.1443 116.12 42.5228 116.12C42.9014 116.12 43.4061 115.994 43.5323 115.615"
          stroke="#00B0AC"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.1511 85.041C18.5486 86.6833 20.946 88.5783 23.0911 90.4733C23.722 91.105 24.3529 91.7367 25.11 92.1157C25.867 92.4947 26.8765 92.621 27.6336 92.1157"
          stroke="#00B0AC"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M155.959 117.131C156.464 116.752 156.969 116.247 157.221 115.741C157.726 114.731 157.474 113.467 157.095 112.457C156.717 111.446 156.212 110.309 155.959 109.298C155.455 106.266 157.978 103.487 158.609 100.455C157.095 101.845 155.707 103.234 154.571 105.003C153.436 106.645 152.805 108.667 152.805 110.688C152.931 113.467 153.562 115.741 153.057 118.394C154.193 118.647 155.076 117.889 155.959 117.131Z"
          fill="#058293"
        />
        <path
          d="M160.502 122.816C162.395 122.942 164.035 123.953 165.423 125.216C166.811 126.48 167.82 127.996 168.83 129.638C167.316 128.754 165.801 127.996 164.035 127.869C162.521 127.743 161.133 128.248 159.619 128.375C157.852 128.501 151.795 126.732 152.174 123.953C152.3 122.184 158.988 122.69 160.502 122.816Z"
          fill="#058293"
        />
        <path
          d="M151.417 115.995C151.796 114.1 151.165 112.079 150.66 110.184C149.398 112.963 147.758 115.616 145.865 118.016C145.234 118.901 144.477 119.785 144.098 120.922C142.963 124.712 146.117 123.196 147.632 121.806C149.398 120.29 150.912 118.395 151.417 115.995Z"
          fill="#058293"
        />
        <path
          d="M150.786 126.606C151.543 127.237 152.174 127.995 152.805 128.88C154.067 130.648 155.329 132.543 156.59 134.312C154.319 133.049 152.3 131.533 150.408 129.764C150.029 129.385 149.524 128.88 149.02 128.627C148.01 128.122 146.748 128.627 145.613 128.753C143.215 129.132 139.43 126.353 142.963 125.216C144.982 124.458 149.146 125.342 150.786 126.606Z"
          fill="#058293"
        />
        <path
          d="M166.306 119.658C167.82 119.405 169.208 118.9 170.47 118.015C171.732 117.131 172.615 115.868 172.868 114.352C171.984 115.362 170.975 116.373 169.587 116.626C168.704 116.878 167.694 116.626 166.685 116.499C164.161 116.247 160.628 117.005 158.862 119.026C160.88 120.289 164.287 120.037 166.306 119.658Z"
          fill="#058293"
        />
        <path
          d="M167.316 108.162C167.821 106.898 167.947 105.509 167.947 104.245C167.947 103.361 168.073 102.35 167.568 101.719C166.685 103.361 165.928 105.003 165.045 106.646C164.54 107.656 163.909 108.793 163.278 109.678C162.395 110.815 159.871 114.352 163.278 113.468C164.792 112.962 166.685 109.551 167.316 108.162Z"
          fill="#058293"
        />
        <path
          d="M173.12 110.309C174.256 109.045 175.265 107.656 176.653 106.645C178.924 105.255 181.827 105.382 184.35 106.013C185.233 106.266 186.243 106.392 187 105.887C185.107 105.129 183.215 104.245 181.196 103.866C179.177 103.487 177.032 103.487 175.139 104.371C172.742 105.382 170.344 108.161 169.335 110.561C167.947 114.225 171.732 111.825 173.12 110.309Z"
          fill="#058293"
        />
        <path
          d="M174.003 107.529C172.741 108.54 171.606 109.677 170.344 110.814C169.461 111.698 168.577 112.583 167.568 113.214C166.18 114.225 164.54 114.73 162.899 115.362C159.366 116.752 155.959 118.52 152.805 120.668C151.669 121.426 150.534 122.31 149.272 122.816C146.496 124.079 143.341 123.953 140.565 125.09C138.294 125.974 136.275 127.743 134.887 129.764C133.878 131.154 132.994 132.543 131.985 133.807C130.849 135.07 129.588 136.207 127.947 136.46"
          stroke="#00B0AC"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M166.306 107.404C165.423 110.563 162.899 112.963 161.637 115.869"
          stroke="#00B0AC"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M154.698 110.814C154.824 111.446 155.202 112.078 155.328 112.709C155.328 113.088 155.328 113.467 155.202 113.846C154.95 114.857 154.698 115.994 154.193 116.878C153.814 117.51 153.31 118.142 152.805 118.773C152.426 119.405 152.048 120.163 152.174 121.047"
          stroke="#00B0AC"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M144.098 124.205C144.603 122.942 145.36 121.679 146.243 120.668C147.379 119.405 148.893 118.394 149.65 117.004C149.903 116.499 150.155 115.994 150.029 115.488"
          stroke="#00B0AC"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M161.638 125.596C159.492 125.975 157.221 125.343 155.202 124.585C154.571 124.332 153.814 124.08 153.183 123.701C152.805 123.448 152.426 123.069 152.048 122.816C151.543 122.564 150.912 122.438 150.407 122.438"
          stroke="#00B0AC"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M148.01 126.858C146.875 126.226 145.487 125.973 144.099 126.1C143.341 126.1 142.584 126.352 141.827 126.226C141.575 126.226 141.323 126.1 141.07 125.973C140.818 125.847 140.692 125.594 140.692 125.342"
          stroke="#00B0AC"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M166.559 118.142C164.666 118.142 162.647 118.395 160.754 118.774C160.25 118.9 159.619 119.026 158.988 118.9C158.357 118.774 157.852 118.521 157.6 118.016"
          stroke="#00B0AC"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.2266 44.7413H74.5728C77.9796 44.7413 80.6294 41.9619 80.6294 38.6773V6.84133C80.6294 3.43034 77.8535 0.777344 74.5728 0.777344H24.2266C20.8197 0.777344 18.1699 3.55667 18.1699 6.84133V38.5509C18.1699 41.9619 20.9459 44.7413 24.2266 44.7413Z"
          fill="#FFC40A"
        />
        <path
          d="M41.261 42.214C41.261 42.214 35.2043 45.3723 34.321 50.4257C34.0687 51.5626 32.5545 52.068 31.7974 51.1837C29.7785 49.1623 27.3811 45.1197 27.3811 37.666"
          fill="#FFC40A"
        />
        <path
          d="M35.8352 26.6764C37.9955 26.6764 39.7468 24.923 39.7468 22.7601C39.7468 20.5971 37.9955 18.8438 35.8352 18.8438C33.6749 18.8438 31.9236 20.5971 31.9236 22.7601C31.9236 24.923 33.6749 26.6764 35.8352 26.6764Z"
          fill="white"
        />
        <path
          d="M49.4626 26.6764C51.623 26.6764 53.3742 24.923 53.3742 22.7601C53.3742 20.5971 51.623 18.8438 49.4626 18.8438C47.3023 18.8438 45.551 20.5971 45.551 22.7601C45.551 24.923 47.3023 26.6764 49.4626 26.6764Z"
          fill="white"
        />
        <path
          d="M63.0903 26.6764C65.2506 26.6764 67.0019 24.923 67.0019 22.7601C67.0019 20.5971 65.2506 18.8438 63.0903 18.8438C60.93 18.8438 59.1787 20.5971 59.1787 22.7601C59.1787 24.923 60.93 26.6764 63.0903 26.6764Z"
          fill="white"
        />
        <path
          d="M33.4379 134.31C23.3434 133.931 13.249 137.974 6.68756 144.417C3.40686 147.701 5.93048 152.755 10.9777 153.134C57.4123 155.787 103.847 154.523 150.281 154.018C187.252 153.513 177.284 144.796 171.101 140.627C163.026 135.068 159.997 135.194 152.805 133.931C119.872 128.625 85.9291 127.488 52.4912 130.646"
          fill="#E5EEF3"
        />
        <path
          d="M134.887 72.2812H29.5264V75.3132H134.887V72.2812Z"
          fill="#024390"
        />
        <path
          d="M108.516 36.4023L60.3145 72.2809H29.5264L77.3489 36.4023H108.516Z"
          fill="#024390"
        />
        <path
          d="M108.516 36.4023V39.4343L60.3145 75.3129V72.2809L108.516 36.4023Z"
          fill="#012A66"
        />
        <path
          d="M104.352 39.4336H77.6013V59.3942L62.0811 70.8905V143.027H146.748V70.8905L104.352 39.4336Z"
          fill="#0454A2"
        />
        <path
          d="M77.6013 39.4336L35.2046 70.8905V143.027H119.872V70.8905L77.6013 39.4336Z"
          fill="#0384D5"
        />
        <path
          d="M89.0838 95.1465H66.1189V143.027H89.0838V95.1465Z"
          fill="#0454A2"
        />
        <path
          d="M146.748 73.1645L108.768 44.6133H111.418L104.352 39.4336H77.6013V44.6133L125.802 80.4918H146.748V73.1645Z"
          fill="#024390"
        />
        <path
          d="M77.6013 39.4336L125.802 75.3122H156.591L108.768 39.4336H77.6013Z"
          fill="#024390"
        />
        <path
          d="M77.6013 36.4023L125.802 72.2809H156.591L108.768 36.4023H77.6013Z"
          fill="#0454A2"
        />
        <path
          d="M77.6013 36.4023V39.4343L125.802 75.3129V72.2809L77.6013 36.4023Z"
          fill="#012A66"
        />
        <path
          d="M156.59 72.2812H125.802V75.3132H156.59V72.2812Z"
          fill="#012A66"
        />
        <path
          d="M35.2046 70.8905V76.1965L77.6013 44.6132L119.872 76.1965V70.8905L77.6013 39.4336L35.2046 70.8905Z"
          fill="#0075C8"
        />
        <path
          d="M156.59 73.7969H125.802"
          stroke="#0454A2"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M109.147 97.6738H99.9353V117.761H109.147V97.6738Z"
          fill="white"
        />
        <path
          d="M114.951 95.1465H109.146V117.76H114.951V95.1465Z"
          fill="#0454A2"
        />
        <path
          d="M99.9352 95.1465H94.1309V117.76H99.9352V95.1465Z"
          fill="#0454A2"
        />
        <path
          d="M113.815 96.5371H110.03V105.759H113.815V96.5371Z"
          stroke="#024390"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M98.9258 96.5371H95.1404V105.759H98.9258V96.5371Z"
          stroke="#024390"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M113.815 107.148H110.03V116.371H113.815V107.148Z"
          stroke="#024390"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M98.9258 107.148H95.1404V116.371H98.9258V107.148Z"
          stroke="#024390"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M99.9353 109.802V95.2734H106.371V103.485C106.244 106.896 103.468 109.802 99.9353 109.802Z"
          fill="#0075C8"
        />
        <path
          d="M109.146 109.802V95.2734H102.711V103.485C102.711 106.896 105.613 109.802 109.146 109.802Z"
          fill="#0075C8"
        />
        <path
          d="M138.294 97.6738H129.083V117.761H138.294V97.6738Z"
          fill="#E5E5E5"
        />
        <path
          d="M144.099 95.1465H138.294V117.76H144.099V95.1465Z"
          fill="#024390"
        />
        <path
          d="M129.083 95.1465H123.279V117.76H129.083V95.1465Z"
          fill="#024390"
        />
        <path
          d="M142.963 96.5371H139.178V105.759H142.963V96.5371Z"
          stroke="#012A66"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M128.074 96.5371H124.288V105.759H128.074V96.5371Z"
          stroke="#012A66"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M142.963 107.148H139.178V116.371H142.963V107.148Z"
          stroke="#012A66"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M128.074 107.148H124.288V116.371H128.074V107.148Z"
          stroke="#012A66"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M129.083 109.802V95.2734H135.518V103.485C135.518 106.896 132.616 109.802 129.083 109.802Z"
          fill="#0062B1"
        />
        <path
          d="M138.294 109.802V95.2734H131.859V103.485C131.859 106.896 134.761 109.802 138.294 109.802Z"
          fill="#0062B1"
        />
        <path
          d="M55.3936 96.5371H46.1824V117.761H55.3936V96.5371Z"
          fill="white"
        />
        <path
          d="M61.1979 95.1465H55.3936V117.76H61.1979V95.1465Z"
          fill="#0454A2"
        />
        <path
          d="M46.3085 95.1465H40.5042V117.76H46.3085V95.1465Z"
          fill="#0454A2"
        />
        <path
          d="M60.1885 96.5371H56.4031V105.759H60.1885V96.5371Z"
          stroke="#024390"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M45.2991 96.5371H41.5137V105.759H45.2991V96.5371Z"
          stroke="#024390"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M60.1885 107.148H56.4031V116.371H60.1885V107.148Z"
          stroke="#024390"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M45.2991 107.148H41.5137V116.371H45.2991V107.148Z"
          stroke="#024390"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M46.1824 109.802V95.2734H52.6176V103.485C52.6176 106.896 49.7154 109.802 46.1824 109.802Z"
          fill="#0075C8"
        />
        <path
          d="M55.3935 109.802V95.2734H48.9583V103.485C49.0844 106.896 51.8604 109.802 55.3935 109.802Z"
          fill="#0075C8"
        />
        <path
          d="M89.0838 85.7988H66.1189V91.1048H89.0838V85.7988Z"
          fill="#0075C8"
        />
        <path
          d="M85.803 121.803C86.5696 121.803 87.191 121.181 87.191 120.413C87.191 119.646 86.5696 119.023 85.803 119.023C85.0365 119.023 84.415 119.646 84.415 120.413C84.415 121.181 85.0365 121.803 85.803 121.803Z"
          fill="#FFC40A"
        />
        <path
          d="M37.9805 77.207H116.086"
          stroke="#0075C8"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M76.2133 98.6836H69.021V115.486H76.2133V98.6836Z"
          stroke="#024390"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M85.8029 98.6836H78.6106V115.486H85.8029V98.6836Z"
          stroke="#024390"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M77.6014 68.3643C80.9464 68.3643 83.658 65.6494 83.658 62.3003C83.658 58.9513 80.9464 56.2363 77.6014 56.2363C74.2563 56.2363 71.5447 58.9513 71.5447 62.3003C71.5447 65.6494 74.2563 68.3643 77.6014 68.3643Z"
          stroke="#024390"
          strokeWidth="0.75"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M116.339 140.88C115.834 136.585 118.484 132.542 121.638 129.637C124.793 126.731 128.705 124.71 131.733 121.678C132.616 128.626 130.345 135.827 125.802 141.133C125.929 141.133 121.008 147.323 116.339 140.88Z"
          fill="#56D7C1"
        />
        <path
          d="M121.134 142.396C120.25 137.596 117.096 132.921 112.175 129.258C111.923 134.058 113.689 138.985 117.096 143.407L117.979 144.165C118.862 144.923 120.124 144.797 120.755 143.912C121.134 143.407 121.26 142.902 121.134 142.396Z"
          fill="#058192"
        />
        <path
          d="M42.0181 140.88C42.5228 136.585 39.873 132.542 36.7185 129.637C33.564 126.731 29.6524 124.71 26.624 121.678C25.7408 128.626 28.012 135.827 32.5545 141.133C32.5545 141.133 37.4756 147.323 42.0181 140.88Z"
          fill="#56D7C1"
        />
        <path
          d="M37.2231 142.396C38.1064 137.596 41.2609 132.921 46.182 129.258C46.4343 134.058 44.6678 138.985 41.2609 143.407L40.3777 144.165C39.4944 144.923 38.2326 144.797 37.6017 143.912C37.3493 143.407 37.2231 142.902 37.2231 142.396Z"
          fill="#058192"
        />
        <path
          d="M51.9864 134.941C54.0052 136.205 55.3932 138.226 56.0241 140.374C57.1598 138.605 59.0525 137.342 61.0714 136.963C61.1976 136.963 59.5572 141.132 59.3048 141.511C58.5478 142.521 56.9074 144.416 55.5194 144.29C52.2387 144.29 51.734 137.215 51.9864 134.941Z"
          fill="#56D7C1"
        />
        <path
          d="M107.632 134.941C105.613 136.205 104.225 138.226 103.594 140.374C102.459 138.605 100.566 137.342 98.5472 136.963C98.421 136.963 100.061 141.132 100.314 141.511C101.071 142.521 102.711 144.416 104.099 144.29C107.38 144.29 107.885 137.215 107.632 134.941Z"
          fill="#56D7C1"
        />
        <path
          d="M157.852 91.4849H118.736C116.086 91.4849 114.067 89.3373 114.067 86.8106V62.0493C114.067 59.3963 116.212 57.375 118.736 57.375H157.852C160.502 57.375 162.521 59.5227 162.521 62.0493V86.6843C162.521 89.3373 160.502 91.4849 157.852 91.4849Z"
          fill="#FFC40A"
        />
        <path
          d="M144.603 89.5907C144.603 89.5907 149.398 92.1173 150.029 96.0337C150.155 96.918 151.417 97.297 152.048 96.6653C153.562 95.023 155.455 91.991 155.455 86.1797"
          fill="#FFC40A"
        />
        <path
          d="M127.695 78.2202C129.367 78.2202 130.723 76.8628 130.723 75.1883C130.723 73.5137 129.367 72.1562 127.695 72.1562C126.022 72.1562 124.667 73.5137 124.667 75.1883C124.667 76.8628 126.022 78.2202 127.695 78.2202Z"
          fill="white"
        />
        <path
          d="M138.294 78.2202C139.966 78.2202 141.322 76.8628 141.322 75.1883C141.322 73.5137 139.966 72.1562 138.294 72.1562C136.621 72.1562 135.266 73.5137 135.266 75.1883C135.266 76.8628 136.621 78.2202 138.294 78.2202Z"
          fill="white"
        />
        <path
          d="M148.893 78.2202C150.566 78.2202 151.922 76.8628 151.922 75.1883C151.922 73.5137 150.566 72.1562 148.893 72.1562C147.221 72.1562 145.865 73.5137 145.865 75.1883C145.865 76.8628 147.221 78.2202 148.893 78.2202Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="187"
            height="154"
            fill="white"
            transform="translate(0 0.777344)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DealerLPFormSuccessSVG;
